<template>
    <div class="m-task">
        <h5 class="title task"></h5>

        <div class="task-view">
            <div class="task-item" :class="'t-' + (index + 1)" v-for="(item,index) in task_config" :key="index">
                <div class="index" :class="'i-' + (index + 1) "></div>
                <div class="task-detail">
                    <div class="task-title">{{ item.task }}
                    <span v-if="item.max >= 1 && item.name != 'team'">
                    （<em v-if="item.name == 'share'">{{ $store.state.account.shareCnt || 0 }}</em>
                      <em v-if="item.name == 'sign'">{{ $store.state.account.signCnt || 0 }}</em>
                      <em v-if="item.name == 'pack' && !$store.state.account.special">0</em>
                      <em v-if="item.name == 'pack' && $store.state.account.special > 0">1</em>
                    /{{ item.max }}）</span>
                    </div>
                    <p class="slogen" v-html="item.slogen"></p>
                    <div class="reward-list">
                        <ul>
                            <li v-for="(r,k) in item.gift" :key="k" class="game-item">
                                <div class="pack-icon" v-tips="r.id">
                                    <game-item :id="r.id" :num="r.num" :locked="true"></game-item>
                                </div>                                
                            </li>
                        </ul>
                    </div>

                    <div class="u-btn" :class="[{'disabled' : !item.flag || !$store.state.userinfo.areaId},item.name]" v-if="item.type == 'task'" @click="item.method"></div>
                    <div class="u-btn apply" :class="item.name" v-if="item.type == 'task' && item.flag == 1" @click="item.method"></div>
                    <div class="u-btn dismiss" :class="item.name" v-if="item.type == 'task' && item.flag == 9 && item.name != 'share' && item.name != 'team'"></div>
                    <div class="u-btn" :class="item.name" v-if="item.type == 'task' && item.flag == 9 && item.name == 'share'"  @click="item.method"></div>
                    <div class="u-btn" :class="item.name" v-if="item.name == 'team' && item.flag == 9 && $store.state.team.length < 5"  @click="item.method"></div>
                    <div class="u-btn dismiss" :class="item.name" v-if="item.name == 'team' && item.flag == 9 && $store.state.team.length == 5"></div>
                    <div class="u-btn pack" :class="{'disabled ': !item.flag}" v-if="item.name == 'pack'"  @click="item.method"></div>
                    <div class="u-btn pack dismiss" v-if="item.name == 'pack' && item.flag == 9 "  @click="item.method"></div>
                </div>
            </div>
        </div>

        <div class="pack-info">
            <h6 class="title exchange"></h6>
            <div class="reward-list exchange">
                <ul>
                    <li v-for="(item,index) in pack_config" :key="index" class="game-item">
                        <div class="pack-icon" v-tips="item.id">
                            <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                        </div>                                             
                    </li>
                </ul>
            </div>
            <p class="notice">温馨提示：领取到的燃梦火炬将直接发放到游戏中，请于游戏预热活动中兑换奖励。</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.m-task{
    @media screen and (min-width: 900px) {
        .title.task{
            width: 803px;
            height: 96px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/pc/title-2.png);
        }
        
        .title.exchange{
            width: 684px;
            height: 66px;
            margin: 0 auto 30px;
            background-image: url(~@/assets/images/pc/title-exchange.png);
        }

        .reward-list{

            &.exchange{
                width: 648px;
                margin: 0 auto 35px;
            }

            ul{
                display: flex;
                justify-content: space-between;
            }
        }

        .game-item{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 104px;
            height: 105px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-item.png);

            .pack-icon{
                width: 46px;
                height: 46px;
            }
        }
        
        .notice{
            text-align: center;
            color: #ab664e;
            font-size: 18px;
        }
        
        .task-view{
            position: relative;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 1287px;
            margin: 0 auto;            

            .task-item{
                position: relative;
                width: 628px;
                height: 372px;
                margin-bottom: 35px;
                padding-left: 158px;
                padding-right: 18px;
                padding-top: 31px;
                box-sizing: border-box;

                @for $i from 1 through 4{
                    &.t-#{$i}{
                        background-image: url(~@/assets/images/pc/evt-#{$i}.png);
                    }
                }

                .u-btn{
                    position: absolute;
                    bottom: 30px;
                    right: 131px;
                    width: 222px;
                    height: 66px;
                    background-image: url(~@/assets/images/pc/btn-apply_task.png);

                    &.team{
                        background-image: url(~@/assets/images/pc/btn-team.png);
                    }

                    &.share{
                        background-image: url(~@/assets/images/pc/btn-apply_share.png);
                    }
                    
                    &.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                    }

                    &.apply.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }

                    &.sign.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                    
                    
                    &.pack.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                      
                }
            }

            .task-title{
                font-family: 'HYJinKaiJ';
                font-size: 36px;
                font-weight: 700;
                text-align: center;
                background-image:-webkit-linear-gradient(top,#c84534,#da654e); 
                -webkit-background-clip:text; 
                -webkit-text-fill-color:transparent;                      
            }

            .slogen{
                margin-bottom: 30px;
                font-family: '楷体';
                font-size: 21px;
                text-align: center;
                color: #8d684b;

                b{
                    font-weight: 400;
                    color: #c03b20;;
                }
            }
        }
    }

    @media screen and (max-width: 899px) {
        .title.task{
            width: 709px;
            height: 132px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/m/title-2.png);
        }
        
        .title.exchange{
            width: 684px;
            height: 67px;
            margin: 0 auto 30px;
            background-image: url(~@/assets/images/m/title-exchange.png);
        }

        .reward-list{

            &.exchange{
                width: 648px;
                margin: 0 auto 35px;
            }

            ul{
                display: flex;
                justify-content: space-between;
            }
        }

        .game-item{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 104px;
            height: 105px;
            margin: 0 auto;
            background-image: url(~@/assets/images/pc/bg-item.png);

            .pack-icon{
                width: 46px;
                height: 46px;
            }
        }
        
        .notice{
            text-align: center;
            color: #ab664e;
            font-size: 18px;
        }
        
        .task-view{
            position: relative;
            .task-item{
                position: relative;
                width: 628px;
                height: 372px;
                margin: 0 auto 20px;
                padding-left: 158px;
                padding-right: 18px;
                padding-top: 31px;
                box-sizing: border-box;

                @for $i from 1 through 4{
                    &.t-#{$i}{
                        background-image: url(~@/assets/images/pc/evt-#{$i}.png);
                    }
                }

                .u-btn{
                    position: absolute;
                    bottom: 30px;
                    right: 131px;
                    width: 222px;
                    height: 66px;
                    background-image: url(~@/assets/images/pc/btn-apply_task.png);

                    &.team{
                        background-image: url(~@/assets/images/pc/btn-team.png);
                    }

                    &.share{
                        background-image: url(~@/assets/images/pc/btn-apply_share.png);
                    }
                    
                    &.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply_dismiss.png);
                    }
                    
                    &.apply.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }
                    
                    &.sign.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                    
                    
                    &.pack.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                    }                      
                }
            }

            .task-title{
                font-family: 'HYJinKaiJ';
                font-size: 36px;
                font-weight: 700;
                text-align: center;
                background-image:-webkit-linear-gradient(top,#c84534,#da654e); 
                -webkit-background-clip:text; 
                -webkit-text-fill-color:transparent;                      
            }

            .slogen{
                margin-bottom: 30px;
                font-family: '楷体';
                font-size: 21px;
                text-align: center;
                color: #8d684b;

                b{
                    font-weight: 400;
                    color: #c03b20;;
                }                
            }
        }
        
        .pack-info{
            margin-top: 40px;
        }
    }
}
</style>

<style>
.slogen b{
    font-weight: 400;
    color: #e55f24;
}
</style>

<script>
export default {
    data (){
        return {
            task_config : [
                {
                    task : '完成组队',
                    slogen : '完成小队组队，可直接领取<b>燃梦火炬x15</b>',
                    type : 'task',
                    method : this.call_team,
                    flag : this.$store.state.account.team,
                    name : 'team',
                    apply_url : ajax_url_map.team_gift,
                    max : 1,
                    cnt : 0,                    
                    gift :  [{id : 'ML71',name : '',num : 15},{id : 'ML72',name : '',num : 1},{id : 'LJ30',name : '',num : 1},{ id : 'E559',name : '',num : 2 }],
                },
                {
                    task : '每日签到',
                    slogen : '每日游戏内签到后可于页面领取<b>燃梦火炬x1</b>',
                    type : 'task',
                    method : this.call_sign,
                    flag : this.$store.state.account.sign,
                    name : 'sign',
                    apply_url : ajax_url_map.sign_gift,
                    max : 10,
                    cnt : 0,
                    gift :  [{id : 'ML71',name : '',num : 1},{id : 'AK00',name : '',num : 5},{id : 'AK01',name : '',num : 5}],
                },
                {
                    task : '每日分享',
                    slogen : '每日分享页面给好友，可获得<b>燃梦火炬x1</b>',
                    type : 'task',
                    method : this.call_share,
                    flag : this.$store.state.account.share,
                    name : 'share',
                    apply_url : ajax_url_map.url_gift,
                    max : 10,
                    cnt : 0,
                    gift :  [{id : 'ML71',name : '',num : 1},{id : 'KR48',name : '',num : 1},{id : 'E981',name : '',num : 10}],
                },
                {
                    task : '购买特惠礼',
                    slogen : '购买小队特惠礼可获得<b>燃梦火炬x10</b>',
                    type : 'pack',
                    name : 'pack',
                    method : this.call_pack,
                    flag : this.$store.state.account.special,
                    apply_url : ajax_url_map.url_gift,
                    max : 1,
                    cnt : 0,
                    gift :  [{id : 'ML71',name : '',num : 10},{id : 'AN07',name : '',num : 5},{id : 'KR48',name : '',num : 5}],
                },                                                
            ],
            pack_config : [{id : 'LY49',name : '',num : 10},{id : 'LE95',name : '',num : 10},{id : 'X472',name : '',num : 20},{id : 'LY31',name : '',num : 10},{id : 'X230',name : '',num : 100}],
        }
    },
    computed:{
        aid (){
            return this.$store.state.account.areaId;
        },
    },
    watch: {
        aid: {
            handler(newVal, oldVal) {
                var boonFrom = [this.$store.state.account.team,this.$store.state.account.sign,this.$store.state.account.share,this.$store.state.account.special];
                for(var i = 0;i < this.task_config.length;i++){
                    var ele = this.task_config[i];
                    ele.flag = boonFrom[i] || 0;
                }         
            },
            deep: true
        },        
    },    
    methods : {
        call_team (){

            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();

            if(!this.$store.state.team.length)return this.$warn_modal();
            
            this.$share_modal();
        },
        call_sign (){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();            
            
            this.$axios.get(ajax_url_map.sign_gift)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功，奖励已发放至对应账号的军师邮件中，请注意查收。'});
                    // let val = this.$store.state.userinfo.signCnt + 1;
                    // val = Math.min(val , 10);
                    // this.$store.commit("$_setSignCnt", val);
                    this.task_config[1].flag = 9;
                    this.$update_user();               
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },
        call_share (){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();
            
            //TODO
            this.$web_share();           
        },
        call_pack(){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();
                              
            this.$axios.get(ajax_url_map.team_pack_gift)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功，奖励已发放至对应账号的军师邮件中，请注意查收。'});
                    this.task_config[3].flag = 9;
                    this.$store.commit("$_setSPFlag", 9);
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },
        apply (url,item){
            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.account.areaId)return this.$bind_modal();
            
            this.$axios.get(url)
            .then(
                res => {
                    this.$msg_modal({'text' : '领取成功，奖励已发放至对应账号的军师邮件中，请注意查收。'});
                    this.$update_user();  
                    item.flag = 9;
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },      
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/task.vue